import React, { useEffect, useState } from 'react';

import { useTeam, useSeason, useSelector } from '../shared/hooks';
import { useBreadcrumbs, usePath } from '../../hooks';
import CombinationExplorer from './CombinationExplorer';
import { useCombinationExplorer } from './useCombinationExplorer';
import { useCombinationsFilter } from './CombinationsFilter/useCombinationsFilter';
import { usePossessionsFilter } from './PossessionsFilter/usePossessionsFilter';
import { useSimplePossessionsFilter } from './SimplePossessionsFilter/useSimplePossessionsFilter';
import { seasonName, teamName, checkIfNCAA } from '../../lib/format';
import { getConferenceOptions } from '../LineupExplorer/LineupsFilter/filterOptions';

function createBreadcrumbs(team, season, pathTo) {
  const bc = [
    { title: 'Teams', url: pathTo('teams') },
    { title: `[${seasonName(season)}] ${teamName(team)}`, url: pathTo('team') },
    { title: 'Player Combinations', url: pathTo('combinations') },
    { title: 'Combination Explorer' },
  ];
  return bc;
}

const CombinationExplorerPage = ({ leagueId, seasonId, teamId }) => {
  const team = useTeam(teamId);
  const season = useSeason(seasonId);
  const pathTo = usePath(leagueId, seasonId, teamId);
  useBreadcrumbs(createBreadcrumbs, [team, season, pathTo]);
  const league = team && team.leagues.find(l => l.id === +leagueId);
  const isNCAA = checkIfNCAA(team);
  const division = useSelector(getConferenceOptions(), isNCAA ? 'in' : '');
  const conference = useSelector(getConferenceOptions());

  const [possessions, setPossessions] = useState([]);
  const combinationFilter = useCombinationsFilter(league, team);
  const filters = combinationFilter.data;
  const baseReport = useCombinationExplorer(
    leagueId,
    seasonId,
    teamId,
    filters,
  );

  const report = useCombinationExplorer(
    leagueId,
    seasonId,
    teamId,
    filters,
    possessions,
  );
  const possessionsFilter = usePossessionsFilter(baseReport.possessionGroups);
  const active = possessionsFilter.data.active || [];
  useEffect(() => {
    if (active.length < 2) {
      if (possessions.length) setPossessions([]);
    } else {
      const max = Math.max.apply(null, active);
      const min = Math.min.apply(null, active);
      setPossessions([min, max]);
    }
  }, [active, possessions.length]);

  const simplePossessionsFilter = useSimplePossessionsFilter(baseReport);
  const activePossessions = simplePossessionsFilter.possessions;
  useEffect(() => {
    if (!activePossessions.min || !activePossessions.max) {
      if (possessions.length) setPossessions([]);
    } else {
      setPossessions([activePossessions.min, activePossessions.max]);
    }
  }, [activePossessions, possessions.length]);

  return (
    <CombinationExplorer
      team={team}
      report={report}
      combinationFilter={combinationFilter}
      possessionsFilter={possessionsFilter}
      simplePossessionsFilter={simplePossessionsFilter}
      season={season}
      division={division}
      conference={conference}
    />
  );
};

export default CombinationExplorerPage;
